import { useMemo } from 'react'

import {
  type MenuGroup,
  filterMenuGroups,
  menuGroups,
} from '~/components/layouts/MainLayout/menuGroups'
import { useReleaseGate } from '~/hooks/releaseGate'

/**
 * gate (flag) を解決した上で、 いま描画してよい menu group を返す。
 * 側面メニュー (TopMenu) と副パネル (MainLayout) が同じ結果を使う。
 */
export const useVisibleMenuGroups = (): MenuGroup[] => {
  const workflowAutomation = useReleaseGate('workflowAutomation')
  const splitSupplyPlan = useReleaseGate('splitSupplyPlan')
  return useMemo(
    () => filterMenuGroups(menuGroups, { workflowAutomation, splitSupplyPlan }),
    [workflowAutomation, splitSupplyPlan],
  )
}
